export const SAVE_DEFAULTS_DIALOG_TEXT =
  'You have made changes to the time range or the variables values. Would you like to save these as defaults?';
export const SAVE_DEFAULT_TIME_RANGE_TEXT =
  'You have made changes to the time range. Would you like to save this as default?';
export const SAVE_CHANGES_WITH_SAVED_VIEWS_TEXT =
  'You have made changes to the time range or variable values. Choose how to save these changes.';
